import { generalEndpoints } from './objects/general';
import { systemEndpoints } from './objects/system';
import { userEndpoints } from './objects/user';

export interface IAPIEndpoint {
  url: string;
  version: string;
  method: string;
  options: any;
  _before?: any;
}

export const ApiEndpoints = {
  ...userEndpoints,
  ...systemEndpoints,
  ...generalEndpoints,
};
